import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Shipment } from 'services/action';
import { Form } from 'ui/components';

const initialState = {
  unit_price: 0,
  cod_value: 0,
};

export const FormUpdatePricing = ({ onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ unit_price, cod_value }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      action: 'unit_price',
      unit_price,
      cod_value,
    };
    const req = await Dispatch(Shipment.$updatePartial(data?.id, payload));

    if (req?.message === 'success') {
      onSubmit();
    }
  };

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      unit_price: data?.unit_price,
      cod_value: data?.shipment?.cod_value,
    }));
  }, [data]);

  return (
    <Form autoComplete="off">
      <div className="row">
        <div className="col-md-12">
          <Form.Input
            value={cod_value}
            required
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                cod_value: e.target.valueNumber,
              }));
            }}
            type="number"
            label="COD Value"
            error={StateForm?.errors?.cod_value}
          />
          <Form.Input
            value={unit_price}
            required
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                unit_price: e.target.valueNumber,
              }));
            }}
            type="number"
            label="Unit Price"
            error={StateForm?.errors?.unit_price}
          />
        </div>
      </div>

      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100 mb-3'
            : 'btn btn-primary px-3 w-100 mb-3'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </Form>
  );
};
